/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Action_Bar_Waiting_Finals_ReadyInputs */



/**
* | output |
* | --- |
* | "Round {n} complete. Check in for next round or start finals." |
*
* @param {Action_Bar_Waiting_Finals_ReadyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const action_bar_waiting_finals_ready = /** @type {((inputs: Action_Bar_Waiting_Finals_ReadyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Bar_Waiting_Finals_ReadyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ronde ${i?.n} terminée. Pointez pour la prochaine ronde ou lancez la finale.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Ronda ${i?.n} completada. Haga check-in para la siguiente ronda o inicie la final.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Rodada ${i?.n} completa. Faça o check-in para a próxima rodada ou inicie a final.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Round ${i?.n} completato. Fai il check-in per il prossimo round o avvia la finale.`)
	return /** @type {LocalizedString} */ (`Round ${i?.n} complete. Check in for next round or start finals.`)
});